export default {
	getDrawerState: (state) => {
		return state.drawerState;
	},
};
